import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import SafetySection from './components/SafetySection';
import PremiumSection from './components/PremiumSection';
import FinalCTA from './components/FinalCTA';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#05070d]">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <SafetySection />
        <PremiumSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
